import { PriceCompareMessage } from '../../../../../types/PriceCompareMessage';
import { ReachInformationCategory } from '../../../../../types/ReachInformationMessage';
import { sortCategory } from '../../../../common/helpers/sortByCategory.helper';
import { useEnums } from '../../../../common/hooks/useEnums';
import { ScheduleItem } from '../components/ScheduleProductCard';

export interface CategoryColumn {
    key: string;
    label: string;
    items: Array<{
        scheduleItem: ScheduleItem;
        categoryData: PriceCompareMessage[] | null;
        reachInformation?: ReachInformationCategory;
    }>;
}

export const useScheduleProductColumns = (scheduleList: ScheduleItem[]): CategoryColumn[] => {
    const { getHumanReadableValue } = useEnums();

    const getAllCategories = (): Array<{ key: string; label: string }> => {
        const firstScheduleItem = scheduleList[0];
        if (!firstScheduleItem) return [];

        const allCategories = new Set<string>();
        scheduleList.forEach((item) => {
            if (item.prices) {
                Object.keys(item.prices).forEach((cat) => allCategories.add(cat));
            }
        });

        return Array.from(allCategories)
            .sort(sortCategory)
            .map((category) => ({
                key: category,
                label: getHumanReadableValue('vesselTankCategory', category),
            }));
    };

    const categories = getAllCategories();
    const firstScheduleItem = scheduleList[0];
    if (!firstScheduleItem) return [];

    return categories.map((category) => {
        const items = scheduleList.map((scheduleItem) => {
            let categoryData: PriceCompareMessage[] | null = null;
            let reachInformation: ReachInformationCategory | undefined = undefined;

            if (scheduleItem.prices) {
                categoryData = scheduleItem.prices[category.key] || null;
                reachInformation = scheduleItem.reachInformation?.[category.key];
            }

            return {
                scheduleItem,
                categoryData,
                reachInformation,
            };
        });

        return {
            key: category.key,
            label: category.label,
            items,
        };
    });
};
